import {mapGetters, mapActions} from 'vuex';
import Jt from 'common/util/jt';

const Jt_L = Jt.loader;

export default {
    data() {
        return {
            item: {
                title: '',
                tag: '',
                img: '',
                source: ''
            },
            useAdTemplate: false // 是否使用广告模版
        }
    },
    computed: {
        ...mapGetters({
            scrollPos: 'app:scrollPos',
            onLine: 'detail:onLine',
            endReqNum: 'detail:endReqNum',
            isExist: 'detail:isExist',
            loading: 'detail:loading',
            normal: 'detail:normal',
            rcmd: 'detail:rcmd',
            sourceIcon: 'detail:sourceIcon',
            version: 'detail:version'
        })
    },
    watch: {
        'endReqNum'(newVal, oldVal) {
            if(newVal !== oldVal && newVal === 2) {
                this.$nextTick(function() {
                    const pos = this.scrollPos[this.$route.path];
                    if(pos) {
                        window.scrollTo(0, this.scrollPos[this.$route.path]);
                    }
                });
            }
        },
        'rcmd'(newVal, oldVal) {
            if(newVal && newVal.length) {
                this.$nextTick(function() {
                    this.lazyLoadImg.start();
                });
            }
            if(!this.inApp) {
                this.$nextTick(function() {
                    this.setMlinkOptions();
                });
            }
        }
    },
    methods: {
        ...mapActions({
            init: 'detail:init'
        }),
        reload() {
            this.$store.dispatch('detail:reload', this.$route.params.id)
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/mixin/page-detail.js